import { AxiosInstance } from 'axios';
import { BaseRepository } from '../../Utils/BaseRepository';

export class ProviderRepository extends BaseRepository {
  constructor(client: AxiosInstance) {
    super(client, 'providers');
  }

  public async setAccountStatus(entityId: string, state = 'reactivate', data: any) {
    return this.client.post(`providers/${entityId}/${state}/`, data);
  }
}

